const SubType = [{ id: 1, name: "Fiction" }, { id: 2, name: "Non-Fiction" }];

export { SubType };
